import { useState, useEffect } from 'react';
import { withRouter } from "react-router";
import { Grid, Button, Menu, MenuItem, Paper, Tabs, Tab, Box, Snackbar } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DateFnsUtils from '@date-io/date-fns';
import Alert from '@material-ui/lab/Alert';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { PullHistoryService, LoanService, DealerService } from '../../services';
import { formatDate } from '../../utils/formatters';
import FundingRequests from './FundingRequests';
import Payments from './Payments';
import ProcessingPayments from './ProcessingPayments';
import Returns from './Returns';
import Notifications from './Notifications';
import Rules from './Rules';
import PullHistory from './PullHistory';
import ConfirmationModal from '../../components/ConfirmationModal'
import NLSFilePreviewModal from '../../components/NLSFilePreviewModal'
import LoadingModal from '../../components/LoadingModal';
import Holds from './Holds';
import NlsAuditLogs from './NlsAuditLogs';
import { useNotification } from '../../contexts/NotificationContext';
import { useRole } from '../../contexts/RolesContext';
import { useError } from '../../contexts/ErrorContext';
import AutoSendFRStatus from '../../components/AutoSendFRStatus';
import SuccessFailModal from '../../components/SuccessFailModal';
import { isSuccessfulResponse } from '../../utils/responseHelpers';

const getInitialDate = (props) => {
  const initDate = new URLSearchParams(props.location.search).get("date");

  return initDate ?
    initDate : new Date();
}

const getInitialTab = (props) => {
  const initTab = new URLSearchParams(props.location.search).get("tab");

  return initTab ?
    parseInt(initTab) : 1;
}

const DailyProcessing = (props) => {
    const [selectedDate, setSelectedDate] = useState(getInitialDate(props));
    const [selectedTab, setSelectedTab] = useState(getInitialTab(props));
    const [showNachaSuccess, setShowNachaSuccess] = useState(false);
    const [showNachaError, setShowNachaError] = useState(false);
    const [showNachaReturnsError, setShowNachaReturnsError] = useState(false);
    const [showNachaTrxnsError, setShowNachaTrxnsError] = useState(false);

    const [showThreadNachaError, setShowThreadNachaError] = useState(false);
    const [showThreadNachaReturnsError, setShowThreadNachaReturnsError] = useState(false);
    const [showThreadNachaTrxnsError, setShowThreadNachaTrxnsError] = useState(false);

    const [autoSend, setAutoSend] = useState(false);
    const [fundingNotificationsSent, setFundingNotificationsSent] = useState(false);
    const [showPaymentConfirmationBox, setShowPaymentConfirmationBox] = useState(false);
    const [showNLSFundingPreview, setShowNLSFundingPreview] = useState(false);
    const [showNLSPaymentPreview, setShowNLSPaymentPreview] = useState(false);
    const [showNLSRefundPreview, setShowNLSRefundPreview] = useState(false);

    const [showLoadingModal, setShowLoadingModal] = useState(false);
    const [showSuccessFailModal, setShowSuccessFailModal] = useState(false);
    const [modalDialog, setModalDialog] = useState('');
    const [successfulResponse, setSuccessfulResponse] = useState(false);

    const [showFundingReportConfirmationBox, setShowFundingReportConfirmationBox] = useState(false);
    const [nachaError, setNachaError] = useState(null);
    const [nachaReturnsError, setNachaReturnsError] = useState(null);
    const [nachaTrxnsError, setNachaTrxnsError] = useState(null);

    const [threadNachaError, setThreadNachaError] = useState(null);
    const [threadNachaReturnsError, setThreadNachaReturnsError] = useState(null);
    const [threadNachaTrxnsError, setThreadNachaTrxnsError] = useState(null);

    const [wsfsNachaReturnsError, setWsfsNachaReturnsError] = useState(null);
    const [showWsfsNachaReturnsError, setShowWsfsNachaReturnsError] = useState(false);

    const [anchorNacha, setAnchorNacha] = useState(null);
    const [anchorNLS, setAnchorNLS] = useState(null);

    const [paymentsData, setPaymentsData] = useState(null);
    const [processingPaymentsData, setProcessingPaymentsData] = useState(null);
    const [fundingRequestsData, setFundingRequestsData] = useState(null);
    const [returnsData, setReturnsData] = useState(null);
    const [notificationsData, setNotificationsData] = useState(null);
    const [rulesData, setRulesData] = useState(null);
    const [nlsAuditLogsData, setNlsAuditLogsData] = useState(null);

    const { createNotification, createErrorNotification } = useNotification();
    const { isDailyProcessingWrite, isSuperAdmin } = useRole();
    const { showError } = useError();

    const togglePaymentConfirmation = () => setShowPaymentConfirmationBox(!showPaymentConfirmationBox);
    const toggleFundingReportConfirmation = () => setShowFundingReportConfirmationBox(!showFundingReportConfirmationBox);
    const openNLSFundingPreview = () => { handleNLSMenuClose(); setShowNLSFundingPreview(true); };
    const openNLSPaymentPreview = () => { handleNLSMenuClose(); setShowNLSPaymentPreview(true); };
    const openNLSRefundPreview = () => { handleNLSMenuClose(); setShowNLSRefundPreview(true); };
    const openLoadingModal = () => setShowLoadingModal(true);
    const closeLoadingModal = () => setShowLoadingModal(false);
    const openSuccessFailModal = () => setShowSuccessFailModal(true);
    const closeSuccessFailModal = () => setShowSuccessFailModal(false);
    const changeDialog = (value) => setModalDialog(value);
    const changeSuccessfulResponse = (value) => setSuccessfulResponse(value);


    const handleDateChange = (date) => {
      try {
        let formattedDate = formatDate(date);
        if(formattedDate !== 'Invalid Date') {
          setSearchParam('date', formattedDate);
          setSelectedDate(date);
        }
      } catch (error) {
        showError(error);
      }
    }

    const handleTabSelect = (event, newValue) => {
      setSearchParam('tab', newValue);

      setSelectedTab(newValue);
    }

    const setSearchParam = (param, value) => {
      let searchParams = new URLSearchParams(props.location.search);
      searchParams.set(param, value);

      props.history.push({
        pathname: '/lms/daily-processing',
        search: "?" + searchParams.toString()
      });
    }

    const handleExportNachaClick = (event) => {
      setAnchorNacha(event.currentTarget);
    }

    const handleNachaClose = () => {
      setAnchorNacha(null);
    }

    const handleNLSMenuClick = (event) => {
      setAnchorNLS(event.currentTarget);
    }

    const handleNLSMenuClose = () => {
      setAnchorNLS(null);
    }

    const handleThreadReturnsExport = (event) => {
      LoanService.downloadThreadNachaReturnsFile(selectedDate).then(() => {
        setShowNachaSuccess(true);
        handleNachaClose();
      }).catch(error => {
        setThreadNachaReturnsError(error.response?.data?.error);
        setShowThreadNachaReturnsError(true);
      });
    }

    const handleWSFSReturnsExport = (event) => {
      LoanService.downloadWsfsNachaReturnsFile(selectedDate).then(() => {
        setShowNachaSuccess(true);
        handleNachaClose();
      }).catch(error => {
        setWsfsNachaReturnsError(error.response?.data?.error);
        setShowWsfsNachaReturnsError(true);
      });
    }

    const handleThreadPaymentsExport = (event) => {
      LoanService.downloadThreadNachaFile(selectedDate).then(() => {
        setShowNachaSuccess(true);
        handleNachaClose();
      }).catch(error => {
        setThreadNachaError(error.response?.data?.error);
        setShowThreadNachaError(true);
      });
    }

    const handleWSFSPaymentsExport = (event) => {
      LoanService.downloadNachaFile(selectedDate).then(() => {
        setShowNachaSuccess(true);
        handleNachaClose();
      }).catch(error => {
        setShowNachaSuccess(error.response?.data?.error);
        setShowNachaError(true);
      });
    }

    // Context wasn't updating correctly for this, maybe because of the file download?
    const handleAllNachaExport = (event) => {
      handleNachaClose();
      Promise.all(
        [
          LoanService.downloadNachaFile(selectedDate).then(() => {
            setShowNachaSuccess(true);
          }).catch(error => {
            setNachaError(error.response?.data?.error);
            setShowNachaError(true);
          }),
          LoanService.downloadThreadNachaFile(selectedDate).catch(error => {
            setThreadNachaError(error.response?.data?.error);
            setShowThreadNachaError(true);
          }),
          LoanService.downloadWsfsNachaReturnsFile(selectedDate).catch(error => {
            setWsfsNachaReturnsError(error.response?.data?.error);
            setShowWsfsNachaReturnsError(true);
          }),
          LoanService.downloadThreadNachaReturnsFile(selectedDate).catch(error => {
            setThreadNachaReturnsError(error.response?.data?.error);
            setShowThreadNachaReturnsError(true);
          }),
          DealerService.downloadNachaTrxnFile().catch(error => {
            setNachaTrxnsError(error.response?.data?.error);
            setShowNachaTrxnsError(true);
          }),
        ]
      ).then();
    }

    const handleTestTrxnsNachaExport = (event) => {
      handleNachaClose();
      Promise.all(
        [
          DealerService.downloadNachaTrxnFile().then(() => {
            setShowNachaSuccess(true);
          }).catch(error => {
            setNachaTrxnsError(error.response?.data?.error);
            setShowNachaTrxnsError(true);
          }),
        ]
      ).then();
    }

    const handleSendNotificationsClick = (event) => {
      togglePaymentConfirmation();
      LoanService.sendDailyProcessingNotifications(selectedDate).then(response => {
        if (isSuccessfulResponse(response)) {
          createNotification('Daily Payment Notifications Sent');
        } else {
          createErrorNotification('Failed to Send Daily Payment Notifications');
        }
      }).catch(showError);
    }

    const handleNLSFundingSend = (xmlContent) => {
      setShowNLSFundingPreview(false);
      openLoadingModal();
      LoanService.sendNLSFundingUpdate(xmlContent).then(response => {
        if (isSuccessfulResponse(response)) {
          changeSuccessfulResponse(true);
          changeDialog('Successfully updated NLS!');
        } else {
          changeSuccessfulResponse(false);
          changeDialog('Unable to update NLS.');
        }
        closeLoadingModal();
        openSuccessFailModal();
      }).catch(error => {
        PullHistoryService.getPullHistoryByID(error.response?.data?.errID).then(response => {
          if (isSuccessfulResponse(response)) {
            const errorDialog = `${response.data.operation}: ${response.data.status}`;
            changeDialog(errorDialog);
          }
        }).catch(() => {
          changeDialog('Unable to update NLS.');
        });
        changeSuccessfulResponse(false);
        closeLoadingModal();
        openSuccessFailModal();
      });
    }

    const handleNLSPaymentSend = (xmlContent) => {
      setShowNLSPaymentPreview(false);
      openLoadingModal();
      LoanService.sendNLSPaymentUpdate(xmlContent).then(response => {
        if (isSuccessfulResponse(response)) {
          changeSuccessfulResponse(true);
          changeDialog('Successfully updated NLS!');
        } else {
          changeSuccessfulResponse(false);
          changeDialog('Unable to update NLS.');
        }
        closeLoadingModal();
        openSuccessFailModal();
      }).catch(error => {
        PullHistoryService.getPullHistoryByID(error.response?.data?.errID).then(response => {
          if (isSuccessfulResponse(response)) {
            const errorDialog = `${response.data.operation}: ${response.data.status}`;
            changeDialog(errorDialog);
          }
        }).catch(() => {
          changeDialog('Unable to update NLS.');
        });
        changeSuccessfulResponse(false);
        closeLoadingModal();
        openSuccessFailModal();
      });
    }

    const handleNLSRefundSend = (xmlContent) => {
      setShowNLSRefundPreview(false);
      openLoadingModal();
      LoanService.sendNLSRefundUpdate(xmlContent).then(response => {
        if (isSuccessfulResponse(response)) {
          changeSuccessfulResponse(true);
          changeDialog('Successfully updated NLS!');
        } else {
          changeSuccessfulResponse(false);
          changeDialog('Unable to update NLS.');
        }
        closeLoadingModal();
        openSuccessFailModal();
      }).catch(error => {
        PullHistoryService.getPullHistoryByID(error.response?.data?.errID).then(response => {
          if (isSuccessfulResponse(response)) {
            const errorDialog = `${response.data.operation}: ${response.data.status}`;
            changeDialog(errorDialog);
          }
        }).catch(() => {
          changeDialog('Unable to update NLS.');
        });
        changeSuccessfulResponse(false);
        closeLoadingModal();
        openSuccessFailModal();
      });
    }

    const handleDownloadNLSUpdateClick = (event) => {
      handleNLSMenuClose();
      LoanService.downloadNLSFundingXML(selectedDate).then(() => {
        createNotification('Successfully downloaded NLS Funding XML!');
      }).catch(showError);

      LoanService.downloadNLSPaymentXML(selectedDate).then(() => {
        createNotification('Successfully downloaded NLS Payment XML!');
      }).catch(showError);

      LoanService.downloadNLSRefundXML(selectedDate).then(() => {
        createNotification('Successfully downloaded NLS Refund XML!');
      }).catch(showError);
    }

    const handleFundingReportClick = (event) => {
      LoanService.sendDailyFundingReport(selectedDate).then(response => {
        if (isSuccessfulResponse(response)) {
          createNotification('Daily Funding Report Sent');
          setAutoSend({sendStatus: 'true', toggleAutoSend: 'true'});
          LoanService.setAutoSendStatus('true', 'true');
        } else {
          createErrorNotification('Failed to Send Daily Funding Report');
        }
      }).catch(showError);
    }

    const handleAutoSendClick = () => {
      toggleFundingReportConfirmation();
      setAutoSend((autoSend) => {
        return {
          sendStatus: autoSend.sendStatus,
          toggleAutoSend: autoSend.toggleAutoSend === 'true' ? 'false' : 'true',
        };
      });
      const isCurrentlyEnabled = autoSend.toggleAutoSend === 'true';
      const newToggleValue = isCurrentlyEnabled ? 'false' : 'true';
      LoanService.setAutoSendStatus(autoSend.sendStatus, newToggleValue).catch(showError);
    };

    const closeNachaSuccess = () => {
      setShowNachaSuccess(false);
    }

    const closeNachaError = () => {
      setNachaError(null);
      setShowNachaError(false);
    }

    const closeNachaReturnsError = () => {
      setNachaReturnsError(null);
      setShowNachaReturnsError(false);
    }

    const closeNachaTrxnsError = () => {
      setNachaTrxnsError(null);
      setShowNachaTrxnsError(false);
    }

    const closeThreadNachaError = () => {
      setThreadNachaError(null);
      setShowThreadNachaError(false);
    }

    const closeThreadNachaReturnsError = () => {
      setThreadNachaReturnsError(null);
      setShowThreadNachaReturnsError(false);
    }

    const closeWsfsNachaReturnsError = () => {
      setWsfsNachaReturnsError(null);
      setShowWsfsNachaReturnsError(false);
    }

    const closeThreadNachaTrxnsError = () => {
      setThreadNachaTrxnsError(null);
      setShowThreadNachaTrxnsError(false);
    }

    const fetchProcessingPayments = () => {
      LoanService.getProcessingPaymentsFromDailyProcessing(selectedDate).then(data => {
        setProcessingPaymentsData(data);
        setShowLoadingModal(false);
      }).catch(showError);
    }

    const fetchPayments = () => {
      LoanService.getPaymentsFromDailyProcessing(selectedDate).then(data => {
        setPaymentsData(data);
        setShowLoadingModal(false);
      }).catch(showError);
    }

    const fetchFundingRequests = () => {
      LoanService.getFundingRequestsFromDailyProcessing(selectedDate).then(data => {
        setFundingRequestsData(data);
        setShowLoadingModal(false);
      }).catch(showError);
    }

    const fetchReturns = () => {
      LoanService.getReturnsFromDailyProcessing(selectedDate).then(data => {
        setReturnsData(data);
        setShowLoadingModal(false);
      }).catch(showError);
    }

    const fetchNotifications = () => {
      LoanService.getNotificationsFromDailyProcessing(selectedDate).then(data => {
        setNotificationsData(data);
        setShowLoadingModal(false);
      }).catch(showError);
    }

    const fetchRules = () => {
      LoanService.getRulesFromDailyProcessing(selectedDate).then(data => {
        setRulesData(data);
        setShowLoadingModal(false);
      }).catch(showError);
    }

    const fetchNlsAuditLogs = () => {
      LoanService.getNlsAuditLogsFromDailyProcessing(selectedDate).then(data => {
        setNlsAuditLogsData(data);
        setShowLoadingModal(false);
      }).catch(showError);
    }

    useEffect(() => {
        setShowLoadingModal(true)

        switch (selectedTab) {
          case 0:
            setShowLoadingModal(false);
            break;
          case 1:
            fetchProcessingPayments();
            break;
          case 2:
            fetchFundingRequests();
            break;
          case 3:
            fetchPayments();
            break;
          case 4:
            fetchReturns();
            break;
          case 5:
            fetchNotifications();
            break;
          case 6:
            fetchRules();
            break;
          case 7:
            setShowLoadingModal(false);
            break;
          case 8:
            fetchNlsAuditLogs();
            break;
          default:
            break;
        }

        LoanService.getAutoSendStatus().then(setAutoSend).catch(showError);

        LoanService.getFundingNotificationStatus().then(data => {
          setFundingNotificationsSent(data.fundingNotificationsSent === 'true');
        }).catch(showError);

        // * Disabling the rule here because React is asking for all
        // *    fetch functions to be in the dependency array
        // *    which then causes an infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate, selectedTab]);

    return (
        <div id="daily-processing-container">
          <h1>Daily Processing</h1>
          <Snackbar open={showNachaSuccess} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeNachaSuccess} severity="success">
              Successfully downloaded Nacha file!
            </Alert>
          </Snackbar>
          <Snackbar open={showWsfsNachaReturnsError} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeWsfsNachaReturnsError} severity="error">
              {`Failed to download WSFS Nacha returns file...'${wsfsNachaReturnsError}'`}
            </Alert>
          </Snackbar>
          <Snackbar open={showThreadNachaError} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeThreadNachaError} severity="error">
              {`Failed to download Thread Nacha file...'${threadNachaError}'`}
            </Alert>
          </Snackbar>
          <Snackbar open={showThreadNachaReturnsError} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeThreadNachaReturnsError} severity="error">
              {`Failed to download Thread Nacha returns file...'${threadNachaReturnsError}'`}
            </Alert>
          </Snackbar>
          <Snackbar open={showThreadNachaTrxnsError} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeThreadNachaTrxnsError} severity="error">
              {`Failed to download Thread Nacha test trxns file...'${threadNachaTrxnsError}'`}
            </Alert>
          </Snackbar>
          <Snackbar open={showNachaError} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeNachaError} severity="error">
              {`Failed to download Nacha file...'${nachaError}'`}
            </Alert>
          </Snackbar>
          <Snackbar open={showNachaReturnsError} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeNachaReturnsError} severity="error">
              {`Failed to download Nacha returns file...'${nachaReturnsError}'`}
            </Alert>
          </Snackbar>
          <Snackbar open={showNachaTrxnsError} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert onClose={closeNachaTrxnsError} severity="error">
              {`Failed to download Nacha test trxns file...'${nachaTrxnsError}'`}
            </Alert>
          </Snackbar>
          <ConfirmationModal title="Confirm" message="Are you sure you want to send payment notifications? Notifications might take a couple minutes to show up in the Notifications tab" onConfirm={handleSendNotificationsClick} onCancel={togglePaymentConfirmation} showConfirmationBox={showPaymentConfirmationBox}/>
          <NLSFilePreviewModal
            open={showNLSFundingPreview}
            onClose={() => setShowNLSFundingPreview(false)}
            onConfirm={(xml) => handleNLSFundingSend(xml)}
            fetchContent={() => LoanService.fetchNLSFundingXML(selectedDate)}
          />
          <NLSFilePreviewModal
            open={showNLSPaymentPreview}
            onClose={() => setShowNLSPaymentPreview(false)}
            onConfirm={(xml) => handleNLSPaymentSend(xml)}
            fetchContent={() => LoanService.fetchNLSPaymentXML(selectedDate)}
          />
          <NLSFilePreviewModal
            open={showNLSRefundPreview}
            onClose={() => setShowNLSRefundPreview(false)}
            onConfirm={(xml) => handleNLSRefundSend(xml)}
            fetchContent={() => LoanService.fetchNLSRefundXML(selectedDate)}
          />
          <ConfirmationModal title="Confirm" message="Are you sure you want to enable/disable auto-send funding reports?" onConfirm={handleAutoSendClick} onCancel={toggleFundingReportConfirmation} showConfirmationBox={showFundingReportConfirmationBox}/>
          <LoadingModal
            open={showLoadingModal}
          />
          <SuccessFailModal
            success={successfulResponse}
            open={showSuccessFailModal}
            dialog={modalDialog}
            onClose={closeSuccessFailModal}
          />

          <Grid container spacing={2} justifyContent="flex-end" direction="row" >
              <Grid item>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Date picker dialog"
                        format="MM/dd/yyyy"
                        value={selectedDate}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        />
                </MuiPickersUtilsProvider>
              </Grid>
            {/* TODO: Do we even need a button or just automate? */}
            {isDailyProcessingWrite() ? (<Grid item>
                <Button variant="contained" color="primary" onClick={handleExportNachaClick} target="_blank" endIcon={<ArrowDropDownIcon/>}>
                    Export Nacha File
                </Button>
                <Menu
                  anchorEl={anchorNacha}
                  open={Boolean(anchorNacha)}
                  onClose={handleNachaClose}>
                  <MenuItem onClick={handleWSFSPaymentsExport}>WSFS Payments</MenuItem>
                  <MenuItem onClick={handleThreadPaymentsExport}>Thread Payments</MenuItem>
                  <MenuItem onClick={handleWSFSReturnsExport}>WSFS Returns</MenuItem>
                  <MenuItem onClick={handleThreadReturnsExport}>Thread Returns</MenuItem>
                  <MenuItem onClick={handleTestTrxnsNachaExport}>Test Trxns</MenuItem>
                  <MenuItem onClick={handleAllNachaExport}>{`All NACHAs`}</MenuItem>
                </Menu>
            </Grid>) : null}
            {
              isDailyProcessingWrite()
              ? (
                  fundingNotificationsSent
                  ? (
                      <Grid item>
                        <Button variant="contained" color="secondary" onClick={togglePaymentConfirmation}>
                          Notifications Sent
                        </Button>
                      </Grid>
                  )
                  : (
                      <Grid item>
                        <Button variant="contained" color="primary" onClick={togglePaymentConfirmation}>
                          Send Notifications
                        </Button>
                      </Grid>
                  )
                )
              : null
            }
            {isDailyProcessingWrite() ? (<Grid item>
                <Button variant="contained" color="primary" onClick={handleNLSMenuClick} target="_blank" endIcon={<ArrowDropDownIcon/>}>
                    NLS
                </Button>
                <Menu
                  anchorEl={anchorNLS}
                  open={Boolean(anchorNLS)}
                  onClose={handleNLSMenuClose}>
                  <MenuItem onClick={openNLSFundingPreview}>Send Funding Requests to NLS</MenuItem>
                  <MenuItem onClick={openNLSPaymentPreview}>Send Payments to NLS</MenuItem>
                  <MenuItem onClick={openNLSRefundPreview}>Send Returns to NLS</MenuItem>
                  {
                    isSuperAdmin() &&
                    <MenuItem onClick={handleDownloadNLSUpdateClick}>Download NLS XMLs</MenuItem>
                  }
                </Menu>
            </Grid>) : null}
            {isDailyProcessingWrite() && autoSend.toggleAutoSend === 'false' ? (<Grid item>
                <Button variant="contained" color="primary" onClick={handleFundingReportClick}>
                    Send Funding Report
                </Button>
            </Grid>) : null }
            {isDailyProcessingWrite() ? (<Grid item>
              <AutoSendFRStatus autoSend={autoSend} title="AUTO-SEND FUNDING REPORT" altTitle="FUNDING REPORT SENT" onClick={toggleFundingReportConfirmation}/>
            </Grid>) : null }
          </Grid>
          <Paper square>
            <Tabs
                value={selectedTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleTabSelect}
                aria-label="disabled tabs example"
            >
                <Tab label="Holds" />
                <Tab label="Processing Payments" />
                <Tab label="Funding Requests" />
                <Tab label="Payments" />
                <Tab label="Returns" />
                <Tab label="Notifications" />
                <Tab label="Rules" />
                <Tab label="Automation History" />
                {isDailyProcessingWrite() ? <Tab label="NLS Audit Logs" /> : null}
            </Tabs>
            <TabPanel value={selectedTab} index={0}>
                <Holds selectedDate={selectedDate} autoSend={autoSend} />
            </TabPanel>
            <TabPanel value={selectedTab} index={1}>
                <ProcessingPayments dailyProcessingData={processingPaymentsData} selectedDate={selectedDate} />
            </TabPanel>
            <TabPanel value={selectedTab} index={2}>
                <FundingRequests dailyProcessingData={fundingRequestsData} selectedDate={selectedDate} />
            </TabPanel>
            <TabPanel value={selectedTab} index={3}>
                <Payments dailyProcessingData={paymentsData} selectedDate={selectedDate} />
            </TabPanel>
            <TabPanel value={selectedTab} index={4}>
                <Returns dailyProcessingData={returnsData} selectedDate={selectedDate} />
            </TabPanel>
            <TabPanel value={selectedTab} index={5}>
                <Notifications dailyProcessingData={notificationsData} selectedDate={selectedDate} />
            </TabPanel>
            <TabPanel value={selectedTab} index={6}>
                <Rules dailyProcessingData={rulesData} selectedDate={selectedDate} />
            </TabPanel>
            <TabPanel value={selectedTab} index={7}>
                <PullHistory selectedDate={selectedDate} />
            </TabPanel>
            {isDailyProcessingWrite() ? (
              <TabPanel value={selectedTab} index={8}>
                <NlsAuditLogs dailyProcessingData={nlsAuditLogsData} />
              </TabPanel>
            ) : null}
          </Paper>
        </div>
    );

}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`wrapped-tabpanel-${index}`}
        aria-labelledby={`wrapped-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            {children}
          </Box>
        )}
      </div>
    );
  }

export default withRouter(DailyProcessing);
